import { LoginFormMode } from "../login.repository";
import "webroot/static/vendor/components/jquery.cookie.js";

export class LoginCookiesService {
	constructor() {
	}

	readForm(): LoginFormMode {
		let currentForm = (<any>$).cookie("authOpenForm");
		// по умолчанию
		if (!currentForm) {
			currentForm = LoginFormMode.educOrg;
		}
		return currentForm;
	}

	writeForm(mode: LoginFormMode): void {
		(<any>$).cookie("authOpenForm", mode);
	}

	readTTSLogin() {
		return ((<any>$).cookie("TTSLogin") || "").split('&')
			.map ((cookie) => cookie.split('='))
			.filter((cookieArr) => typeof cookieArr[1] != "undefined" && cookieArr[1])
			.reduce((res, c) => {
				res[c[0]] = c[1];
				return res;
			}, {});
	}
}